export default __webpack_public_path__ + "static/media/ThinkRent.888fccb7ec9f473b3a46dbce45a5fc43.webp";